import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusReview = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 7,
		fill: "var(--warning-bg)",
		stroke: "var(--warning-border)",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 4.5V8l2.25 1.5",
		stroke: "var(--warning-text)",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export { SvgStatusReview as ReactComponent };
